export default __webpack_public_path__ + "static/media/dd2dbed68a000b52073c289d092dda2b.7e9aca81.png";